import type { Insurer } from 'BrokerTsLib/src/enums'
import * as yup from 'yup'
import { PropertyDataValidationSchema } from '..'

export const isInsurersAvailable = (allInsurers: Insurer[], insurers: Insurer[]) => {
    return (allInsurers?.filter(x => insurers.includes(x))?.length ?? 0) > 0
}

export const isInsurerAvailable = (allInsurers: Insurer[], insurer: Insurer) => {
    return isInsurersAvailable(allInsurers, [insurer])
}

export const PropertyValidationRuleObject = {
    data: yup
        .object()
        .when(['type', 'insurers'], ([type, insurers], schema) => {
            return PropertyDataValidationSchema(type, insurers)
        }),

    insurers: yup
        .array()
        .nullable()
        .required('Vyberte alespoň jednu pojišťovnu')
        .min(1, 'Vyberte alespoň jednu pojišťovnu'),

    type: yup
        .string()
        .nullable()
        .required('Vyberte co chcete pojistit'),

    range: yup
        .string()
        .nullable()
        .required('Zvolte rozsah pojištění'),
}

export const PropertyValidationSchema = yup.object().shape(PropertyValidationRuleObject) as any